<template>
    <!-- 编辑官网管理 -->
    <div class="teamInfo">
        <div class="search_container">
            <el-button size="mini" type="primary" @click="() => { $emit('changeActive', 1) }">返回</el-button>
        </div>
        <div class="comPractice_container">
            <div class="signUp_info_main">
                <div class="left">
                    <h2>{{ groupName }}</h2>
                    <template v-if="teamList && teamList.length > 0">

                        <el-form v-for="(item, i) in studentFormList" :key="i">

                            <div class="formBox">
                                <div class="item only_one">
                                    <el-form-item :prop="`teamName[${n}].${[ele.configField]}_1`" 
                                        :label="ele.configLabel + ++i + '：'" v-for="(ele, n) in item.teamName"
                                        :key="'teamName' + n">
                                        {{ ele[ele.configField + '_1'] }}
                                    </el-form-item>
                                </div>
                                <!-- 领队信息 -->
                                <div class="label">
                                    <p>
                                        领队信息{{ ismaxLeaderCount != 0 ? 1 : '' }}
                                    </p>
                                </div>
                                <div class="commonFlex">
                                    <div class="leaderList" v-for="(val, n) in item.leaderList" :key="'leader' + n">
                                        <div class="item four">
                                            <el-form-item :label="val.configLabel + '：'" v-if="val.configFieldType == 0">
                                                {{ val[val.configField + '_1'] }}
                                            </el-form-item>
                                            <el-form-item v-if="val.configFieldType == 1" :label="val.configLabel + '：'">
                                                <el-select v-model="val[val.configField + '_1']">
                                                    <el-option :label="vs.v" :value="vs.id"
                                                        v-for="(vs, i) in JSON.parse(val.configList)" :key="i"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <!-- 多领队 -->
                                <div v-if="ismaxLeaderCount != 0">
                                    <div v-for="(n, i) in ismaxLeaderCount" :key="n">
                                        <div class="label">
                                            <p>
                                                领队信息 {{ ++n }}
                                            </p>
                                        </div>
                                        <div class="commonFlex">
                                            <div class="leaderList" v-for="(val, n) in item['leaderList_' + i]"
                                                :key="'student' + n">
                                                <div class="item four">
                                                    <el-form-item :label="val.configLabel + '：'" v-if="val.configFieldType == 0">
                                                        {{ val[val.configField + '_1'] }}
                                                    </el-form-item>
                                                    <el-form-item v-if="val.configFieldType == 1" :label="val.configLabel + '：'">
                                                        <el-select v-model="val[val.configField + '_1']">
                                                            <el-option :label="vs.v" :value="vs.id"
                                                                v-for="(vs, i) in JSON.parse(val.configList)"
                                                                :key="i"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 选手信息 -->
                                <div class="label">
                                    <p>
                                        选手信息{{ isNumber != 0 ? 1 : '' }}
                                    </p>
                                </div>
                                <div class="commonFlex">
                                    <div class="studentList" v-for="(val, n) in item.studentList" :key="'student' + n">
                                        <div class="item four">
                                            <el-form-item :label="val.configLabel + '：'" v-if="val.configFieldType == 0">
                                                {{ val[val.configField + '_1'] }}
                                            </el-form-item>
                                            <el-form-item v-if="val.configFieldType == 1"  :label="val.configLabel + '：'">
                                                <el-select v-model="val[val.configField + '_1']">
                                                    <el-option :label="vs.v" :value="vs.id"
                                                        v-for="(vs, i) in JSON.parse(val.configList)" :key="i"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <!-- 多选手信息 -->
                                <div v-if="isNumber != 0">
                                    <div v-for="(n, i) in isNumber" :key="n">
                                        <div class="label">
                                            <p>
                                                选手信息 {{ ++n }}
                                            </p>
                                        </div>
                                        <div class="commonFlex">
                                            <div class="studentList" v-for="(val, n) in item['studentList_' + i]"
                                                :key="'student' + n">
                                                <div class="item four">
                                                    <el-form-item :label="val.configLabel + '：'" v-if="val.configFieldType == 0">
                                                        {{ val[val.configField + '_1'] }}
                                                    </el-form-item>
                                                    <el-form-item v-if="val.configFieldType == 1" :label="val.configLabel + '：'">
                                                        <el-select v-model="val[val.configField + '_1']">
                                                            <el-option :label="vs.v" :value="vs.id"
                                                                v-for="(vs, i) in JSON.parse(val.configList)"
                                                                :key="i"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 指导教师 -->
                                <div>
                                    <div class="label">
                                        <p>
                                            指导教师信息 {{ ismaxTeacherCount != 0 ? 1 : '' }}
                                            <!-- <el-button class="add" @click="addUser(i, item.teacherList)">添加指导教师</el-button>
                                <el-button class="add" @click="deleteUser(i)">删除指导教师</el-button> -->
                                        </p>
                                    </div>
                                    <div class="commonFlex">
                                        <div class="teacherList" v-for="(val, n) in item.teacherList" :key="'teacher' + n">
                                            <div class="item four">
                                                <el-form-item :label="val.configLabel + '：'" v-if="val.configFieldType == 0">
                                                    {{ val[val.configField + '_1'] }}
                                                </el-form-item>
                                                <el-form-item v-if="val.configFieldType == 1" :label="val.configLabel + '：'">
                                                    <el-select v-model="val[val.configField + '_1']">
                                                        <el-option :label="vs.v" :value="vs.id"
                                                            v-for="(vs, i) in JSON.parse(val.configList)"
                                                            :key="i"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 多指导教师 -->
                                <div v-if="ismaxTeacherCount != 0">
                                    <div v-for="(n, i) in ismaxTeacherCount" :key="n">
                                        <div class="label">
                                            <p>
                                                指导教师信息 {{ ++n }}
                                            </p>
                                        </div>
                                        <div class="commonFlex">
                                            <div class="teacherList" v-for="(val, n) in item['teacherList_' + i]"
                                                :key="'teacherList' + n">
                                                <div class="item four">
                                                    <el-form-item :label="val.configLabel + '：'" v-if="val.configFieldType == 0">
                                                        {{ val[val.configField + '_1'] }}
                                                    </el-form-item>
                                                    <el-form-item v-if="val.configFieldType == 1" :label="val.configLabel + '：'">
                                                        <el-select v-model="val[val.configField + '_1']">
                                                            <el-option :label="vs.v" :value="vs.id"
                                                                v-for="(vs, i) in JSON.parse(val.configList)"
                                                                :key="i"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>

                    </template>
                    <template v-else>
                        <div class="no_content">
                            暂无{{ groupName }}报名信息
                        </div>
                    </template>
                    <!-- 审核弹窗 -->
                    <el-dialog title="报名审核" :close-on-click-modal="false" :close-on-press-escape="false"
                        :visible.sync="dialogVisible" width="30%">
                        <h2 style="text-align: center;">审核是否通过？</h2>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="audit_pass(1)" size="small">通过</el-button>
                            <el-button @click="audit_pass(0)" size="small">未通过</el-button>
                        </span>
                    </el-dialog>
                    <!-- 未通过弹窗 -->
                    <el-dialog title="提示" :close-on-click-modal="false" :close-on-press-escape="false"
                        :visible.sync="dialogVisible_audit_nopass" width="30%">
                        <span>请输入审核未通过原因：</span>
                        <p style="margin-top: 10px;">
                            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="cause">
                            </el-input>
                        </p>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="commonReviewReject(0)" size="small">确认</el-button>
                            <el-button @click="dialogVisible = true, dialogVisible_audit_nopass = false"
                                size="small">上一步</el-button>
                        </span>
                    </el-dialog>
                </div>
                <div class="right">
                    <template v-if="deptProofList">
                        <template v-if="deptProofList && deptProofList.length > 0">
                            <div v-for="(item, i) in deptProofList" :key="i" class="img_box">
                                <el-image :src="item.attachUrl" :preview-src-list="[item.attachUrl]"></el-image>
                                <i class="imageName" :title="item.attachName">{{ item.attachName }}</i>
                            </div>
                        </template>
                        <template v-else>
                            <div class="no_content">
                                暂无审核资料
                            </div>
                        </template>
                    </template>
                </div>
            </div>

            <div class="operation">
                <el-button @click="() => { dialogVisible = true }" :type="teamInfoData.isDisabled ? 'default' : 'primary'"
                    :disabled="teamInfoData.isDisabled ? true : false">审核</el-button>
                <el-button @click="goback" type="primary">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import fetch from '@/api/fetch'
export default {
    name: 'teamInfo',

    data() {
        return {
            loading: false,
            deptInfo: null,
            studentList: [],
            teacherList: [],
            heightGroup: [],
            undergraduateGroup: [],
            dialogVisible: false,
            dialogVisible_audit_nopass: false,
            cause: "",
            deptProofList: [],
            groupName: '',
            teamList: [],
            groupData: {},
            isNumber: 1, // 多选手 maxTeamMemberCount
            ismaxLeaderCount: 1, // 多领队 maxLeaderCount
            ismaxTeacherCount: 1, // 多指导教师 maxTeacherCount

            studentFormList: [],
            basicTemplate: {},
            leaderObj: {},
            studentObj: {},
            teacherObj: {},

        }


    },

    props: {
        teamInfoData: {
            type: Object,
            default() {
                return {}
            }
        },
        rowData: {
            type: Object,
            default() {
                return {}
            }
        }
    },

    async mounted() {
        console.log(this.teamInfoData, 'teamInfoData')
        console.log(this.rowData, 'rowData')
        await this.checkRegisterStatus()
        await this.init()
    },
    methods: {
        async checkRegisterStatus() {
            let params = {
                channelId: this.teamInfoData.channelId,
                batchId: this.rowData.batchId,
                userId: this.teamInfoData.userId,
                orgId: this.teamInfoData.orgId,
                // "channelId": 1, "batchId": 1, "userId": "8763144", "orgId": 3745
            }
            const res = await fetch.checkRegisterStatus(params)
            if (res.code == '0') {
                console.log(res, 'res')
                this.groupData = res.data.groupList.find(item => {
                    return item.id == this.rowData.id
                })
                this.isNumber = this.groupData.maxTeamMemberCount - 1;
                this.ismaxLeaderCount = this.groupData.maxLeaderCount - 1
                this.ismaxTeacherCount = this.groupData.maxTeacherCount - 1
            } else {
                this.$message.error(res.msg)
            }

        },
        init() {
            fetch.getAttachList({
                channelId: this.teamInfoData.channelId,
                batchId: this.rowData.batchId,
                orgId: this.teamInfoData.orgId
            }).then(res => {
                if (res.code == 0) {
                    this.deptProofList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            }).then(() => {
                if (this.deptProofList) {
                    this.getTeam()
                }
            })
        },
        compare(p) { //这是比较函数
            return function (m, n) {
                var a = m[p];
                var b = n[p];
                return b - a; //升序
            }
        },
        getTeam() {
            fetch.getTeamPageShow({
                channelId: this.teamInfoData.channelId,
                batchId: this.rowData.batchId,
                groupId: this.rowData.id,
                orgId: this.teamInfoData.orgId
            }).then(res => {
                if (res.code == 0) {
                    this.groupName = res.data.groupName
                    this.studentFormList = []
                    let newMemberConfigList = res.data.memberConfigList.map(item => {
                        return {
                            ...item,
                            [`${item.configField}_1`]: ''
                        }
                    })
                    let obj = newMemberConfigList.reduce((result, item) => {
                        const { memberType } = item;
                        let obj = {
                            0: 'teamName',
                            1: 'leaderList',
                            2: 'studentList',
                            3: 'teacherList'
                        }
                        const key = obj[memberType];
                        if (!result[key]) {
                            result[key] = [];
                        }
                        result[key].push(item);
                        return result;

                    }, {});

                    // 多选手
                    if (this.isNumber) {
                        Object.keys(obj).forEach(item => {
                            for (let i = 0; i < this.isNumber; i++) {
                                if (item == 'studentList') {
                                    obj[`studentList_${i}`] = JSON.parse(JSON.stringify(obj[item]))
                                }
                            }
                        })
                    }

                    // 多领队
                    if (this.ismaxLeaderCount) {
                        Object.keys(obj).forEach(item => {
                            for (let i = 0; i < this.ismaxLeaderCount; i++) {
                                if (item == 'leaderList') {
                                    obj[`leaderList_${i}`] = JSON.parse(JSON.stringify(obj[item]))
                                }
                            }
                        })
                    }

                    // 多指导教师
                    if (this.ismaxTeacherCount) {
                        Object.keys(obj).forEach(item => {
                            for (let i = 0; i < this.ismaxTeacherCount; i++) {
                                if (item == 'teacherList') {
                                    obj[`teacherList_${i}`] = JSON.parse(JSON.stringify(obj[item]))
                                }
                            }
                        })
                    }

                    this.basicTemplate = JSON.parse(JSON.stringify(obj))
                    this.teanmObj = JSON.parse(JSON.stringify(obj.teamName))
                    this.leaderObj = JSON.parse(JSON.stringify(obj.leaderList))
                    this.studentObj = JSON.parse(JSON.stringify(obj.studentList))
                    this.teacherObj = JSON.parse(JSON.stringify(obj.teacherList))
                    console.log(this.studentFormList, '.studentFormList _1')

                    // 回显有过保存队伍
                    if (res.data.teamList && res.data.teamList.length) {
                        // 有多个队伍的情况
                        for (let i = 0; i < res.data.teamList.length; i++) {
                            let copyObj = JSON.parse(JSON.stringify(obj))
                            this.studentFormList.push(copyObj)
                        }
                        this.teamList = res.data.teamList
                        this.getTeamShow(res.data.teamList)
                        return false
                    }
                    this.studentFormList.push(obj)
                    this.teamList = res.data.teamList

                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getTeamShow(arr) {
            arr.forEach((obj, idx) => {
                obj.memberList.forEach((item, ie, newArr) => {
                    const memberType = item.memberType;
                    const jsonContent = JSON.parse(item.jsonContent);
                    // memberType: 0 参赛队伍名称 1领队信息 2选手信息 3指导教师
                    if (memberType === 0) {
                        // 领队信息回显 + 参赛队伍回显
                        Object.keys(this.studentFormList[idx]).forEach(v => {
                            this.studentFormList[idx][v].forEach(vs => {
                                if (vs.memberType == item.memberType) {
                                    vs[`${vs.configField}_1`] = jsonContent[vs.configField]
                                }
                            })
                        })

                    } else if (memberType === 1) { // 领队
                        const firstMemberType1 = newArr.find(item => item.memberType === 1);
                        const otherMemberType1 = newArr.filter(item => item.memberType === 1 && item !== firstMemberType1);

                        Object.keys(this.studentFormList[idx]).forEach(v => {
                            this.studentFormList[idx][v].forEach(vs => {
                                if (firstMemberType1 && vs.memberType == 1) {
                                    vs[`${vs.configField}_1`] = JSON.parse(firstMemberType1.jsonContent)[vs.configField]
                                }

                                // 其他领队信息
                                if (this.ismaxLeaderCount) {
                                    for (let i = 0; i <= this.ismaxLeaderCount; i++) {
                                        if (v.includes('leaderList_')) {
                                            let match = v.match(/\d+/);
                                            let number = parseInt(match[0]);
                                            if (otherMemberType1.length > 0) {
                                                this.studentFormList[idx][v].forEach(el => {
                                                    el[`${el.configField}_1`] = JSON.parse(otherMemberType1[number].jsonContent)[el.configField]
                                                })
                                            }
                                        }
                                    }
                                }
                            })
                        })
                    }
                    else if (memberType === 2) {
                        const firstMemberType2 = newArr.find(item => item.memberType === 2);
                        const otherMemberType2 = newArr.filter(item => item.memberType === 2 && item !== firstMemberType2);
                        // 选手信息回显
                        Object.keys(this.studentFormList[idx]).forEach(v => {
                            this.studentFormList[idx].studentList.forEach(vs => {
                                if (firstMemberType2 && vs.memberType == 2) {
                                    vs[`${vs.configField}_1`] = JSON.parse(firstMemberType2.jsonContent)[vs.configField]
                                }
                            })

                            // 其他选手
                            if (this.isNumber) {
                                for (let i = 0; i <= this.isNumber; i++) {
                                    if (v.includes('studentList_')) {
                                        let match = v.match(/\d+/);
                                        let number = parseInt(match[0]);

                                        this.studentFormList[idx][v].forEach((el) => {
                                            el[`${el.configField}_1`] = JSON.parse(otherMemberType2[number].jsonContent)[el.configField]
                                        })
                                    }
                                }
                            }
                        })
                    }
                    else if (memberType == 3) { // 目前只有一个指导教师
                        const firstMemberType3 = newArr.find(item => item.memberType === 3);
                        const otherMemberType3 = newArr.filter(item => item.memberType === 3 && item !== firstMemberType3);

                        Object.keys(this.studentFormList[idx]).forEach(v => {
                            this.studentFormList[idx][v].forEach(vs => {
                                if (firstMemberType3 && vs.memberType == 3) {
                                    vs[`${vs.configField}_1`] = JSON.parse(firstMemberType3.jsonContent)[vs.configField]
                                }
                            })
                            // 其他指导教师
                            if (this.ismaxTeacherCount) {
                                for (let i = 0; i <= this.ismaxTeacherCount; i++) {
                                    if (v.includes('teacherList_')) {

                                        let match = v.match(/\d+/);
                                        let number = parseInt(match[0]);

                                        this.studentFormList[idx][v].forEach(el => {
                                            el[`${el.configField}_1`] = JSON.parse(otherMemberType3[number].jsonContent)[el.configField]
                                        })
                                    }
                                }
                            }
                        })

                    } else {
                        this.$messageError('memberType 类型 有问题')
                    }
                })
            });
            console.log(this.studentFormList, '.studentFormList_2')
        },
        goback() {
            this.$emit('changeActive', 1)
        },
        audit_pass(type) {//审核通过
            if (type) {
                this.commonReviewReject(type)
            } else {
                this.dialogVisible_audit_nopass = true;
            }

        },
        commonReviewReject(type) { // 0 - 未通过 1- 通过
            console.log(this.teamInfoData, 'teamInfoData')
            if (type) {
                fetch.setApplyPassorglist2({
                    checkIdList: [this.teamInfoData.id],
                    userId: JSON.parse(sessionStorage.getItem('userData')).userId,
                    userName: JSON.parse(sessionStorage.getItem('userData')).username
                }).then(res => {
                    if (res.code == '0') {
                        this.cause = "";
                        this.dialogVisible = false;
                        this.$message.success(res.msg)
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            } else {
                fetch.setApplyRejectlist({
                    checkIdList: [this.teamInfoData.id],
                    userId: JSON.parse(sessionStorage.getItem('userData')).userId,
                    userName: JSON.parse(sessionStorage.getItem('userData')).username,
                    rejectCause: this.cause,
                }).then(res => {
                    if (res.code == '0') {
                        this.$message.success(res.msg)
                        this.cause = "";
                        this.dialogVisible = false;
                        this.dialogVisible_audit_nopass = false;
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }

        },
    },
}

</script>

<style lang="scss" scoped>
.teamInfo {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .search_container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 0 20px;
        box-sizing: border-box;
    }

    .comPractice_container {
        // display: flex;
        width: 100%;
        height: calc(100% - 80px);
        // background-color: #fff;
        // background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        // padding: 10px 20px 20px 20px;
        box-sizing: border-box;

        .signUp_info_main {
            width: 100%;
            height: calc(100% - 110px);
            display: flex;
            justify-content: space-between;
            overflow-x: auto;

            .left {
                flex: 1;
                background: #fff;
                margin: 10px;
                overflow-y: auto;
                padding: 50px;
                padding-top: 10px;
                box-sizing: border-box;

                h2 {
                    line-height: 50px;
                }

                .team {
                    .team_num {
                        line-height: 40px;
                        background: #e8f2ff;
                        position: relative;

                        &::after {
                            content: "";
                            width: 4px;
                            height: 40px;
                            position: absolute;
                            background: rgba(29, 112, 226, 1);
                            left: 0;
                            top: 0;
                        }

                        p {
                            padding-left: 20px;
                        }
                    }

                    .team_info {
                        padding: 0 8%;

                        h3 {
                            line-height: 40px;
                        }

                        p {
                            background: rgba(242, 242, 242, 1);
                            line-height: 40px;
                            padding-left: 10px;
                        }

                        ul {
                            display: flex;
                            flex-wrap: wrap;
                            margin: 0 10px;

                            li {
                                width: 50%;
                                line-height: 40px;
                            }
                        }
                    }
                }

                p {
                    font-size: 20px;
                    font-weight: 700;
                }
            }

            .right {
                width: 30%;
                background: #fff;
                margin: 10px;
                overflow-y: auto;
                padding: 10px;
                box-sizing: border-box;

                .img_box {
                    width: 100%;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    padding: 10px;
                    box-sizing: border-box;
                    margin-bottom: 10px;

                    .el-image {
                        width: 100%;
                        height: 100%;
                    }
                }

                .imageName {
                    width: 100%;
                    display: inline-block;
                    text-align: center;
                    white-space: nowrap;
                    /* 防止文本换行 */
                    overflow: hidden;
                    /* 隐藏超出容器的部分 */
                    text-overflow: ellipsis;
                    /* 显示省略号 */
                }
            }
        }

        .no_content {
            line-height: 100px;
            text-align: center;
            font-size: 16px;
        }

        .operation {
            text-align: center;
            width: 100%;

            button {
                width: 150px;
                height: 50px;
                // background: #0177F9;
                border-radius: 8px;
                // color: #fff;
                font-size: 20px;
                margin-top: 15px;

                &:hover {
                    opacity: 0.8;
                }
            }
        }
    }

    /deep/ .el-form-item {
        margin-bottom: 0;
    }

    .label {
        margin: 20px 10px;
    }

    .formBox {
        border-bottom: 1px dashed #ccc;
       /deep/ .el-form-item {
            font-weight: 700;
            .el-form-item__content {
                font-size: 16px; 
                font-weight: 700;
            }
            .el-form-item__label {
                font-size: 16px; 
                font-weight: 700;
            }
            .el-input__inner {
                font-size: 16px; 
                font-weight: 700;
                color: #000;
            }
        }
    }
    /deep/ .el-input__inner {
        border: none;
        padding: 0px;
    }
    /deep/ .el-input__suffix {
        display: none;
    }
}
</style>